import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/ambassadors/ambassadors.yml';

import { Ambassadors as AmbassadorsBase } from './entryPoint';

// Placeholders are used here (see docs/i18n/index.md) because copy is still being iterated on —
// but they fall back to ALL locales with no translation, so every visitor gets this English copy
// regardless of locale. Move this into config/i18n/corgi.en-US.yml before the public launch
// (routes.config.ts `ssr.seo`).
export const Ambassadors = withI18nPlaceholders(I18N_PLACEHOLDERS, AmbassadorsBase);
